//@flow
import Typography from "@mui/material/Typography";
import React from 'react';
import {Paper} from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import type {Badge} from "../../../types/badge/types";
import PrintBadgeButton from "../printBadgeButton/printBadgeButton";
import {QRCodeSVG} from 'qrcode.react'

type Props = {
    badge: Badge
}

const BadgeDetails = (props: Props) => {
    const {badge, showToolbar} = props
    return (
        <Paper sx={{p: 1}} elevation={0}>
            {showToolbar && (
                <Toolbar disableGutters variant={"dense"} sx={{mb: 2}}>
                    <Box sx={{flexGrow: 1}}/>
                    <PrintBadgeButton
                        userId={badge.user.id}
                        type={badge.type}
                        autoReloadFile={true}
                        printSize={props.printSize}
                    />
                </Toolbar>
            )}
            <Box sx={{'& svg': {width: "100%"}}}>
                <QRCodeSVG value={badge.id} size={200} level="M" />
            </Box>
            <Typography sx={{textAlign: 'center'}}>{badge.id}</Typography>
        </Paper>
    )
}

export default BadgeDetails
